<template>
  <aside class="helpbar-container container-fluid text-center">
    <h4 class="helpbar-title">
      {{ $t('productSettings.helpBar.title') }}
    </h4>
    <p class="helpbar-text mt-3 mb-4">
      {{ $t('productSettings.helpBar.text') }}
    </p>
    <div v-if="isLoading" class="text-center my-5 py-5">
      <div class="spinner-border text-primary align-middle" role="status">
        <span class="visually-hidden">{{ $t('common.loading') }}</span>
      </div>
    </div>
    <div class="cs-info mx-auto" v-show="!isLoading">
      <object :data="csPhoto" type="image/png" :alt="`${csFirstName} ${csLastName}`" width="68">
        <img :src="require('@/assets/user.svg')" :alt="`${csFirstName} ${csLastName}`" width="68" height="68" />
      </object>
      <h5 class="mt-3">{{ csFirstName }} {{ csLastName }}</h5>
      <div class="cs-line" />
      <p class="cs-email">
        <font-awesome-icon :icon="['far', 'envelope']" :style="{ color: '#2054ea' }" class="me-2" />
        <a :href="`mailto:${csEmail}`">{{ csEmail }}</a>
      </p>
      <p class="cs-phone">
        <font-awesome-icon :icon="['far', 'phone']" :style="{ color: '#2054ea' }" class="me-2" />
        {{ csPhone }}
      </p>
    </div>
  </aside>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'HelpBar',
  data() {
    return {
      isLoading: true,
      csImgUrlPrefix: 'https://f.hubspotusercontent40.net/hubfs/875893/profile_pics/',
    };
  },
  computed: {
    ...mapState({
      currentBusinessCSRepInfo: state => state.business.currentBusinessCSRepInfo,
    }),
    csFirstName() {
      return this.currentBusinessCSRepInfo && this.currentBusinessCSRepInfo.firstName
        ? this.currentBusinessCSRepInfo.firstName
        : this.$t('productSettings.helpBar.defaultCsName');
    },
    csLastName() {
      return this.currentBusinessCSRepInfo &&
        this.currentBusinessCSRepInfo.firstName &&
        this.currentBusinessCSRepInfo.lastName
        ? this.currentBusinessCSRepInfo.lastName
        : '';
    },
    csEmail() {
      return this.currentBusinessCSRepInfo &&
        this.currentBusinessCSRepInfo.firstName &&
        this.currentBusinessCSRepInfo.email
        ? this.currentBusinessCSRepInfo.email
        : 'success@autoverify.com';
    },
    csPhone() {
      return this.currentBusinessCSRepInfo &&
        this.currentBusinessCSRepInfo.firstName &&
        this.currentBusinessCSRepInfo.phone
        ? this.currentBusinessCSRepInfo.phone
        : this.$t('productSettings.helpBar.defaultCsPhone');
    },
    csPhoto() {
      const email = this.csEmail.slice(0, this.csEmail.indexOf('@'));
      // Hubspot has strange caching happening. We add a changing query param to stop caching issues on hubspot servers
      const date = new Date().getTime();
      return `${this.csImgUrlPrefix}${email}.png?v=${date}`;
    },
  },
  methods: {
    ...mapActions('business', ['fetchCsRepInformation']),
  },
  created() {
    this.fetchCsRepInformation().finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.helpbar-container {
  background-color: #ffffff;
  position: relative;
  padding: 20px 16px;

  @media (min-width: 1024px) {
    box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.04);
    position: absolute;
    top: 0;
    right: 0;
    width: 299px;
    height: 100%;
    padding-top: 110px;
    padding-bottom: 110px;
    overflow: auto;
  }

  .helpbar-title {
    @media (min-width: 1024px) {
      margin-top: 40px;
    }
  }

  .helpbar-text {
    margin: 0 auto;
    max-width: 265px;

    @media (min-width: 1024px) {
      max-width: 242px;
    }
  }

  .cs-info {
    max-width: 221px;
    margin-top: 40px;
    @media (min-width: 1024px) {
      margin-top: 88px;
    }

    .cs-title {
      color: $light-grey-text;
      font-size: 16px;
      font-weight: normal;
    }

    .cs-line {
      border: 1px solid rgb(218, 226, 234);
      height: 1px;
      width: 42px;
      margin: 16px auto;
    }

    .cs-email,
    .cs-phone {
      color: $blue;
      margin: 16px 0;
      text-align: left;

      @media (min-width: 576px) and (max-width: 1024px) {
        text-align: center;
      }

      @media (min-width: 1024px) {
        text-align: center;
      }
    }

    .cs-phone {
      margin-bottom: 40px;
    }
  }

  .feedback-box {
    background: $blue;
    border-radius: 6px;
    padding: 24px 20px;
    margin-top: 40px;

    @media (min-width: 576px) and (max-width: 1024px) {
      max-width: 345px;
      margin: 40px auto;
    }

    @media (min-width: 1024px) {
      margin-top: 127px;
    }
  }
}
</style>
